import React, { ReactElement } from "react";

import ConditionalWrapper from "@components/ConditionalWrapper";

type FooterColumnType = {
  title?: string;
  children?: ReactElement;
  className?: string;
  wrapperClass?: string;
  [x: string]: any;
};

const FooterColumn = (props: FooterColumnType) => {
  const {
    title, children, wrapperClass = "", className = "", ...rest
  } = props;
  return (
    <div className={`footer__column ${className}`} {...rest}>
      <ConditionalWrapper
        condition={!!wrapperClass}
        wrapper={(children) =>
          <div className={wrapperClass}>{children}</div>}
      >
        <>
          {/* тег h3 (вид h4 по классу .h4) — чтобы футер не давал перескок h2→h4 (SEO #10b) */}
          {title && <h3 className="h4">{title}</h3>}
          {children}
        </>
      </ConditionalWrapper>
    </div>
  );
};

export default FooterColumn;
